import { Button, Dialog } from '@alifd/next';
import React, { useCallback, useState } from 'react';

import SettingForm from './SettingForm';

const ElectricityPriceSetting = ({ setTrigger }) => {
  const [showSetting, setShowSetting] = useState(false);

  const handleClose = useCallback(() => setShowSetting(false), []);
  const handleOpen = useCallback(() => setShowSetting(true), []);

  return (
    <>
      <Button onClick={handleOpen}>充電樁相關設定</Button>
      <Dialog
        title="充電樁相關設定"
        visible={showSetting}
        footer={false}
        onClose={handleClose}
      >
        <SettingForm {...{ handleClose, setTrigger }} />
      </Dialog>
    </>
  );
};

export default ElectricityPriceSetting;
